import script from "./ContactView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactView.vue?vue&type=script&setup=true&lang=ts"

import "./ContactView.vue?vue&type=style&index=0&id=209f1b9f&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-209f1b9f"]])

export default __exports__